<template>
    <div>
        <!-- Header for the group -->
        <div
            class="flex justify-between"
            :class="[
                isPrintMode ?
                    'text-2xl border-b-4 mb-4' :
                    'text-base border-b border-gray-light mb-[22px]'
            ]"
        >
            <div
                v-html="getGroupTitleFromCode(group.code)"
                class="font-semibold"
                :class="[
                    isPrintMode &&'mb-2'
                ]"
            />
            <button
                v-if="!isPrintMode && canEditGroup"
                @click="() => handleRedirectToPanel(group)"
                class="flex items-center bg-none border-none text-[16px]"
            >
                <span class="flex-none text-red underline">{{ $t('EDIT') }}</span>

                <img src="../assets/images/icons/edit.svg" class="flex-none ml-2 h-[14px] w-[14px]" alt="" />
            </button>
            <div v-if="isPrintMode">
                {{ $t('UPCHARGE') }}
            </div>
        </div>

        <!-- If group has subgroups, render each subgroup -->
        <template v-if="group.subgroups && group.subgroups.length > 0">
            <div
                v-for="(subgroup, subIndex) in group.subgroups"
                :key="subgroup.id || subgroup.code"
                class="flex justify-between"
                :class="[
                    (subIndex % 2 === 0 && !isPrintMode) ? 'bg-white' : 'bg-gray-FAFAFA',
                    isPrintMode && 'mb-4'
                ]"
            >
                <current-selection-detailed
                    :placement-data="subgroup"
                    @redirectToPanel="handleRedirectToPanel"
                />
            </div>
        </template>

        <!-- Otherwise render the group itself -->
        <div
            v-else
            class="flex justify-between"
            :class="[
                (index % 2 === 0 && !isPrintMode) ? 'bg-white' : 'bg-gray-FAFAFA',
                isPrintMode && 'mb-4'
            ]"
        >
            <current-selection-detailed
                :placement-data="group"
                @redirectToPanel="handleRedirectToPanel"
            />
        </div>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import CurrentSelectionDetailed from './CurrentSelectionDetailed.vue';

    export default {
        mixins: [allStores],

        components: {
            CurrentSelectionDetailed,
        },

        props: {
            group: {
                type: Object,
                required: true,
            },

            index: {
                type: Number,
                required: true,
            },
        },

        computed: {
            isPrintMode() {
                return this.appStore.isPrintMode;
            },

            canEditGroup() {
                if (this.customizerStore.isSurefitHubLocked(this.group.placements)) {
                    return false;
                }

                return true;
            },
        },

        methods: {
            setSelectedGroup(itemData) {
                this.customizerStore.setCurrentGroup(itemData.name);
            },
            setShowGroupOverlay(value) {
                this.appStore.setShowGroupOverlay(value);
            },
            setShouldShowSummary(value) {
                this.appStore.setShouldShowSummary(value);
            },
            getRedirectTarget(placement) {
                if (placement?.code === 'Paintfill' || placement?.name === 'Paintfill') {
                    return {
                        name: 'Face/Sole',
                    };
                }

                return placement;
            },
            async handleRedirectToPanel(placement) {
                const redirectTarget = this.getRedirectTarget(placement);

                this.setShowGroupOverlay(false);
                await new Promise((resolve) => { setTimeout(resolve, 250); });
                this.setSelectedGroup(redirectTarget);
                this.setShouldShowSummary(false);
                this.setShowGroupOverlay(true);
            },

            getGroupTitleFromCode(code) {
                switch (code) {
                case 'Face/Sole':
                    return 'Face/Sole';
                case 'CharacterStamping':
                    return this.$t('CATEGORY_CHARACTER_STAMPING');
                case 'Stamps':
                    return this.$t('CATEGORY_TOE_ENGRAVING');
                case 'PutterShaftBand':
                    return this.$t('CATEGORY_SHAFT_BAND');
                case 'TopPaintfill':
                    return this.$t('CATEGORY_TOP_PAINTFILL');
                case 'BackPaintfill':
                    return this.$t('CATEGORY_BACK_PAINTFILL');
                default:
                    return this.$te(`CATEGORY_CODE_${code}`) ? this.$t(`CATEGORY_CODE_${code}`) : code;
                }
            },

            getDescriptionText(description) {
                let text = '';

                description.forEach((desc) => {
                    text += ` ${desc.name}`;
                });

                return text.trim();
            },
        },
    };
</script>
